import { toGeoJSON } from '@mapbox/polyline';
import { Feature, Geometry, lineString, lineToPolygon } from '@turf/turf';
import { Entity } from 'dexie';
import { GeoJsonProperties } from 'geojson';
import type { AppDB } from '../db';

export enum TerritoryLayersType {
  Source = 'territoriesSource',
  Layer = 'territoriesLayer',
  Background = 'territoriesBackgroundLayer',
  Highlight = 'territoriesHighlightLayer',
  Text = 'territoriesTextLayer',
}

export enum TerritoryEntityType {
  Department = 'department',
  Region = 'region',
  Country = 'country',
}

export enum TerritoryEntityColor {
  Department = '#799EFF',
  Region = '#3B38A0',
  Country = '#000',
}

const EntityColorMap: Record<TerritoryEntityType, TerritoryEntityColor> = {
  [TerritoryEntityType.Department]: TerritoryEntityColor.Department,
  [TerritoryEntityType.Region]: TerritoryEntityColor.Region,
  [TerritoryEntityType.Country]: TerritoryEntityColor.Country,
};

class Territory extends Entity<AppDB> {
  public uid!: number;
  public code!: string;
  public code_insee_dep!: string | null;
  public code_insee_reg!: string | null;
  public name: string;
  public entity_type: TerritoryEntityType;
  public geom!: string;
  public created!: number;
  public updated!: number;

  public get color(): TerritoryEntityColor {
    return EntityColorMap[this.entity_type];
  }

  public get polygon(): Feature<Geometry, GeoJsonProperties> {
    try {
      const geometry = toGeoJSON(this.geom);
      const line = lineString(geometry.coordinates);
      const polygon = lineToPolygon(line);
      return polygon;
    } catch (err) {
      console.error(`Failed to create polygon for administrative division ${this.code}`, err);
      return null;
    }
  }
}

export default Territory;
